<template>
    <!-- 个人资料 -->
    <div class="beijing">
        <div  class="person">
            <div class="tit">
                个人资料
            </div>
            <div class="touxiang">
                <img :src="imgUrl" alt="">
                <el-upload
                class="upload-demo"
                action="https://serve.dhcang.com/api/upload/image"
                multiple
                :show-file-list="false"
                :headers="headers"
                :before-upload="beforeAvatarUpload"
                :on-success="uploadImgSuccess">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </div>
            <div class="info">
                <div>
                    <div>
                        <span>*</span>昵称
                    </div>
                    <el-input v-model="form.nickname" placeholder="请输入内容"></el-input>
                </div>
                <div>
                    <div>
                        用户编号
                    </div>
                    <el-input disabled v-model="form.sn" ></el-input>
                </div>
            </div>
            <div class="info">
                <div>
                    <div>
                        手机号
                    </div>
                    <el-input disabled v-model="form.mobile" ></el-input>
                </div>
                <div>
                    <div>
                        登录密码
                    </div>
                    <el-input disabled v-model="form.password" ></el-input>
                </div>
            </div>
            <el-button @click="saveInfo" class="baocun">保存</el-button>
        </div>
    </div>
</template>
    
<script>
import { userCenter,setInfo } from "@/api/api";
export default {
    components:{
        
    },
    data() {
        return {
            imgUrl:'',
            form:{},
            headers:{
                'token':localStorage.getItem('token')
            },
        }
    },
    methods: {
        // 获取个人信息
        async getUserInfo(){
            let token = localStorage.getItem('token')
            let headers = {
                'token':token
            }
            try {
                const res = await userCenter(headers);
                if(res.code==1){
                    this.form=res.data
                    this.imgUrl = this.form.avatar
                    if(res.data.has_password){
                        this.form.password="*******"
                    }
                    sessionStorage.setItem('has_password',res.data.has_password);
                    let storedObject = localStorage.getItem('userInfo');
                    if(storedObject){
                        let obj = JSON.parse(storedObject);
                        obj.freeze_money = this.form.freeze_money;
                        obj.user_money = this.form.user_money;
                        obj.total_amount = Number(this.form.user_money) + Number(this.form.freeze_money);
                        localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    }
                }else if(res.code==-1){
                    this.$message({
                        type:'error',
                        message:'登录超时，请重新登录'
                    })
                }
            } catch (error) {
                console.log(error,'获取用户信息失败');
            }
        },
        beforeAvatarUpload(file){
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 或者 PNG 格式!');
            }

            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        // 头像上传成功
        async uploadImgSuccess(res){
            if(res.code==1){
                this.form.avatar = res.data.uri
                // localStorage.setItem('userInfo')
                // this.$message({
                //     message: '上传成功',
                //     type: 'success'
                // });
                let params = {
                    field:'avatar',
                    value:res.data.uri,
                }
                const resTwo = await setInfo(params,this.headers)
                if (resTwo.code==1) {
                    this.imgUrl = res.data.uri
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });

                    let storedObject = localStorage.getItem('userInfo');
                    if (storedObject) { // 检查是否真的有值，避免错误
                        let obj = JSON.parse(storedObject);
                        obj.avatar = this.imgUrl;
                        localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    }
                    location.reload()  // 修改本地存储  刷新页面
                }
            }else{
                this.$message({
                    message: '上传失败',
                    type: 'error'
                });
            }
        },
        // 保存修改的内容
        async saveInfo(){
            try {
                let params = {
                    field:'nickname',
                    value:this.form.nickname,
                }
                const res = await setInfo(params,this.headers)
                if (res.code==1) {
                    let storedObject = localStorage.getItem('userInfo');
                    if (storedObject) { // 检查是否真的有值，避免错误
                        let obj = JSON.parse(storedObject);
                        obj.nickname = this.form.nickname;
                        localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                        location.reload()  // 修改本地存储  刷新页面
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                    }
                }
            } catch (error) {
                console.log(error,'设置用户信息失败');
            }
        }
    },
    mounted(){
        this.getUserInfo()
    }
}
</script>
    
<style style lang="scss" scoped>
.person{
    padding: 32px;
    box-sizing: border-box;

    .tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .touxiang{
        display: flex;
        align-items: center;
        margin-top: 24px;
        img{
            width: 88px;
            height: 88px;
            border-radius: 50%;
            border: 1px solid #FFFFFF;
            margin-right: 16px;
        }

        .el-button{
            width: 100px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 8px 8px 8px 8px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            border: 0;
        }
    }

    .info{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #606260;
        font-style: normal;
        text-transform: none;

        display: flex;

        margin-top: 24px;

        span{
            color: #FE3300;
        }

        :deep(.el-input){
            input{
                width: 280px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;
                color: #333333;
            }

            margin-right: 48px;
            margin-top: 12px;
        }
    }
}

.el-button.baocun{
    width: 100px;
    height: 40px;
    background: #0073F5;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 33px;
}
</style>